// api/users.ts
import { CRUDL } from "../crudl.mjs";
var UsersImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/users/v1");
  }
  async create(user) {
    return await this._crudl.create(user);
  }
  async read(uuid) {
    return this._crudl.read(uuid);
  }
  async delete(uuid) {
    return this._crudl.delete(uuid);
  }
  async update(uuid, update) {
    return this._crudl.update(uuid, update);
  }
  async list(params) {
    return this._crudl.list({ ...params });
  }
  async subscribe(user) {
    await this._crudl.http.post("/users/v1/subscribe", user);
  }
  async unsubscribe(user) {
    await this._crudl.http.post("/users/v1/unsubscribe", user);
  }
  async updatePreferences(uuid, preferences) {
    const response = await this._crudl.http.put(`/users/v1/${uuid}/preferences`, preferences);
    return response.data;
  }
  async exists(email) {
    const response = await this._crudl.http.post("/users/v1/", { email }, {
      headers: { "x-provisional": "true" },
      acceptStatuses: [409]
    });
    return response.status === 409;
  }
  async availableRoles() {
    const response = await this._crudl.http.get("/users/v1/roles");
    return response.data;
  }
  async userRoles(uuid) {
    const response = await this._crudl.http.get(`/users/v1/${uuid}/roles`);
    return response.data;
  }
  async usersWithRole(role_uuid) {
    const response = await this._crudl.http.get(`/users/v1/roles/${role_uuid}/users`);
    return response.data;
  }
  async assignRoles(user_uuid, role_uuids) {
    await this._crudl.http.post(`/users/v1/${user_uuid}/roles`, { roles: role_uuids });
  }
  async removeRole(user_uuid, role_uuid) {
    await this._crudl.http.delete(`/users/v1/${user_uuid}/roles/${role_uuid}`);
  }
};
export {
  UsersImpl
};
//# sourceMappingURL=users.mjs.map
